import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { sort } from 'fast-sort';
import {
  EstateWorkItem,
  useEstateWorkItemNote_GetEstateWorkItemNotesByEstateWorkItemIdQuery,
} from 'queries';

import Spinner from 'common/spinner';
import AssignedTaskNote from 'pages/assigned-tasks-page/components/assigned-task-notes/assigned-task-note';
import { NotificationSeverity, showAlert } from 'utils/notification-manager';
const useStyles = makeStyles(() => ({
  container: {
    color: '#1C2541',
    fontSize: '14px',
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    textAlign: 'left',
  },
  recentNotesContainer: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    overflowY: 'auto',
  },
}));
type TaskActivityNotesProps = {
  estateWorkItem: EstateWorkItem;
};
const TaskActivityNotes = ({ estateWorkItem }: TaskActivityNotesProps) => {
  const classes = useStyles();
  const portalId = estateWorkItem.estate!.portalId;

  const { data: estateWorkItemNotesData, loading: estateWorkItemNotesLoading } =
    useEstateWorkItemNote_GetEstateWorkItemNotesByEstateWorkItemIdQuery({
      variables: {
        id: estateWorkItem.id,
        portalId,
      },
      onError: (e) => {
        showAlert({
          message: 'Error getting estate work item notes: ' + e.message,
          severity: NotificationSeverity.ERROR,
        });
      },
    });

  if (estateWorkItemNotesLoading) {
    return <Spinner />;
  }

  const estateWorkItemNotes = sort(estateWorkItemNotesData?.data || []).desc(
    (estateWorkItemNote) => new Date(estateWorkItemNote.createdAt),
  );

  return (
    <div className={classes.container}>
      <Typography variant="caption">
        <strong>Total Activity Notes:</strong> {estateWorkItemNotes.length}
      </Typography>
      <Box className={classes.recentNotesContainer}>
        {estateWorkItemNotes.map((estateWorkItemNote) => (
          <AssignedTaskNote key={estateWorkItemNote.id} estateWorkItemNote={estateWorkItemNote} />
        ))}
      </Box>
    </div>
  );
};
export default TaskActivityNotes;
